import captureKeyboardListener, { KeyboardCallback } from './captureKeyboardListeners';

export default function captureEscKeyListener(handler: KeyboardCallback, force?: boolean) {
  return captureKeyboardListener({ onEsc: handler }, force);
}
